import { useAppDispatch } from '../../../../ReduxToolkit/Hooks';
import { CartQuantityButtonProp, CartType } from '../../../../Type/Application/Ecommerce/Product';
import { Input } from 'reactstrap';
import { decrementData, incrementData } from '../../../../ReduxToolkit/Reducers/CartSlice';
import { Btn } from '../../../../AbstractElements';

const CartQuantityButton = ({ item }: CartQuantityButtonProp) => {
  const dispatch = useAppDispatch();
  const incrementQty = (product: CartType, quantity: number) => dispatch(incrementData({ item: product, quantity: quantity }));
  const decrementQuantity = (id: number) => dispatch(decrementData(id));
  return (
    <td>
        <div className="touchspin-wrapper">
          <Btn className="decrement-touchspin btn-touchspin touchspin-primary" onClick={() => decrementQuantity(item.id)} >
            <i className="fa fa-minus"></i>
          </Btn >
          <Input className="input-touchspin spin-outline-primary" type="number" value={item.total}/>
          <Btn  className="increment-touchspin btn-touchspin touchspin-primary" onClick={() => incrementQty(item, 1)} >
            <i className="fa fa-plus"></i>
          </Btn>
        </div>
    </td>
  );
}

export default CartQuantityButton